import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstant } from '@app/shared/constants';
import { environment } from '@env/environment';
import { Bug } from '../../models/bug';

@Injectable({
  providedIn: 'root'
})
export class BugService {

  constructor(private http: HttpClient) { }

  SubmitBug(data: Bug) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('userToken')
    });
    return this.http.post<any>(environment.baseUrl + AppConstant.SUBMIT_BUG, data, { headers: headers });
  }
}
